import React from "react";
import Footer from "../components/utils/Footer";
import { QuoteForm } from "../components/forms/QuoteForm";
import NavBar from "../components/utils/NavBar";
const GetAQuote = () => {
  return (
    <div className="h-[100dvh] bg-black antialiased overscroll-contain overflow-x-hidden w-screen">
      <NavBar />

      <section className="bg-black">
        <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
          <h2 className="mb-4 text-5xl font-bold text-primary text-center ">
            Get a Quote
          </h2>
          <p className="mb-8 lg:mb-16 text-center text-white  sm:text-xl">
            Got an idea you would like to bring to life? We can help.
          </p>
          <QuoteForm />
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default GetAQuote;
